import {
  type GenericWebhookIntegration,
  type Integration,
} from '../../generated/graphql';

export type GenericWebhook = {
  name: string;
  id: string;
  urlEndpoint: string;
  accessTokenRef?: string;
  secretRef?: string;
  createdAt: string;
};

export function isGenericWebhookIntegration(
  integration: Integration
): integration is GenericWebhookIntegration {
  return (
    '__typename' in integration &&
    integration.__typename === 'GenericWebhookIntegration'
  );
}

export function toGenericWebhookIntegration(
  integration: Integration
): GenericWebhook | undefined {
  if (isGenericWebhookIntegration(integration)) {
    return {
      ...integration,
      accessTokenRef: integration.accessTokenRef ?? undefined,
      secretRef: integration.secretRef ?? undefined,
    };
  }
  return undefined;
}
